/* eslint-disable no-param-reassign */

import api from '@/services/api/task/task';
import bus from '@/bus'
import Vue from 'vue'
export default {
  state: {
    active: 1,
    member: [],
    isOnlyMyExecutor: false,
    isCheckStatus: false,
    checkTask: [],
    taskModeCheck: {},
    checkBox: [],
    iconList: [
      {
        icon: 'iconicon_bulletin_board',
        components: 'Board',
        key: 1,
        text: '看板'
      },
      {
        icon: 'iconicon_tabulation',
        components: 'TableNew',
        key: 2,
        text: '列表'
      },
      {
        icon: 'iconicon_gantt_chart_chart',
        components: 'Gantt',
        key: 3,
        text: '甘特图'
      }
    ],
    taskParams: {
      task_id: '',
      task_list_id: 0,
      project_id: '',
      isdeleted: false, //是否为已删除的任务
      isShow: false
    },
    queryMsg: {
      task_list_ids: [], // 清单
      keyword: '', // 搜索
      source_filter: [], // 任务来源多选
      status_filter: '', // 任务状态，单选
      sort_method: '', // 按任务天数-quantity, 按执行人姓名A-Z-name
      sorting_rules: [], // 排序规则
      sort_switch: 0, // 是否生效
      executors_uid: [], // 执行人筛选
      task_members_uid: [] // 参与人筛选
    },
    ganttType: 0, // 当前甘特图模式：0-清单，1-执行人
    taskList: [],
    timer: null,
    isDisabledProject: false, // (1)-已归档 (-2)-已冻结, 进入项目是否可更改
  },
  mutations: {
    SET_ACTIVE: (state, data) => {
      state.active = data
    },
    CHANGE_TASK: (state, data) => {
      state.taskParams = data
    },
    set_taskModeCheck: (state, data) => {
      state.taskModeCheck = state.iconList[data]
      state.checkTask = []
      state.checkBox = []
      if (state.taskModeCheck.components !== 'Gantt') {
        state.queryMsg.task_list_ids = []
        state.queryMsg.sort_method = ''
        state.ganttType = 0
      }
    },
    set_source_filter: (state, data) => {
      state.queryMsg.source_filter = data
      state.isCheckStatus = false
      state.checkBox = []
    },
    set_status_filter: (state, data) => {
      state.queryMsg.status_filter = data
      state.isCheckStatus = false
      state.checkBox = []
    },
    set_keyword: (state, data) => {
      state.queryMsg.keyword = data
      state.isCheckStatus = false
      state.checkBox = []
    },
    set_taskList: (state, data) => {
      state.queryMsg.task_list_ids = data
      state.isCheckStatus = false
      state.checkBox = []
    },
    set_checkStatus: (state, data) => {
      state.isCheckStatus = data
      state.checkBox = []
    },
    set_checkTask: (state, data) => {
      let index = state.checkTask.indexOf(data)
      if (index > -1) {
        state.checkTask.splice(index, 1)
      } else {
        state.checkTask.push(data)
      }
    },
    clear_checkTask: (state) => {
      state.checkTask = []
    },
    set_checkBox: (state, data) => {
      state.checkBox = data
    },
    set_timer: (state, data) => {
      state.timer = data
    },
    set_ganttType: (state, data) => {
      state.ganttType = data
      if (data === 1) {
        state.queryMsg.sort_method = 'quantity'
        state.queryMsg.task_list_ids = []
      } else {
        state.queryMsg.sort_method = ''
      }
    },
    set_task_methods: (state, data) => {
      state.queryMsg.sort_method = data
    },
    set_task_member_filter: (state, { executors_uid, task_members_uid }) => {
      state.queryMsg.executors_uid = executors_uid
      state.queryMsg.task_members_uid = task_members_uid
    },
    close_sort_switch: () => {
      state.queryMsg.sort_switch = 0
    },
    clear_task_query: (state, data) => {
      state.isCheckStatus = false
      state.checkBox = []
      state.checkTask = []
      state.queryMsg.task_list_ids = []
      state.queryMsg.keyword = ''
      state.queryMsg.sort_method = ''
      state.queryMsg.executors_uid = []
      state.queryMsg.task_members_uid = []
      state.ganttType = 0
    },
    set_disabled_project: (state, data) => {
      state.isDisabledProject = data
    }
  },
  getters: {},
  actions: {
    changeTemplateListOfSort({ state, rootState }, { sorting_rules, sort_switch }) {
      state.queryMsg.sorting_rules = sorting_rules
      state.queryMsg.sort_switch = sort_switch
      rootState['customKey/customKey'].templateList.map((res) => {
        let result = sorting_rules.find((temp) => temp[res.component_name_in_template])
        res.is_sort = Boolean(result)
        res.sort_value = result?.[res.component_name_in_template]
      })
    },
    closeSortSwitch() {},
    setIsOnlyMyExecutor({ state }, params) {
      state.isOnlyMyExecutor = params
    },
    addChecklist({ commit }, params) {
      return new Promise((resolve, reject) => {
        api
          .addChecklist(params)
          .then((res) => {
            resolve(res)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    editChecklist({ commit }, params) {
      return new Promise((resolve, reject) => {
        api
          .editChecklist(params)
          .then((res) => {
            resolve(res)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    deletetasklist({ commit }, params) {
      return new Promise((resolve, reject) => {
        api
          .deletetasklist(params)
          .then((res) => {
            resolve(res)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    updateorderby({ commit }, params) {
      return new Promise((resolve, reject) => {
        api
          .updateorderby(params)
          .then((res) => {
            resolve(res)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    getTaskList({ commit }, params) {
      return new Promise((resolve, reject) => {
        api
          .getTaskList(params)
          .then((res) => {
            resolve(res)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    addTask({ commit }, params) {
      return new Promise((resolve, reject) => {
        api
          .addTask(params)
          .then((res) => {
            resolve(res)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    editTask({ commit }, params) {
      return new Promise((resolve, reject) => {
        api
          .editTask(params)
          .then((res) => {
            resolve(res)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    delTask({ commit }, params) {
      return new Promise((resolve, reject) => {
        api
          .delTask(params)
          .then((res) => {
            resolve(res)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    updateTaskOrderby({ commit }, params) {
      return new Promise((resolve, reject) => {
        api
          .updateTaskOrderby(params)
          .then((res) => {
            resolve(res)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    gettaskinfo({ commit }, params) {
      return new Promise((resolve, reject) => {
        api
          .gettaskinfo(params)
          .then((res) => {
            resolve(res)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    updatetasktmember({ commit }, params) {
      return api.updatetasktmember(params)
    },
    getArchivedTaskList({ commit }, params) {
      return api.taskIndexUnderTheProject(params)
    },
    archivedTask({ commit }, params) {
      return new Promise((resolve, reject) => {
        api
          .archivedTask(params)
          .then((res) => {
            resolve(res)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    activateTask({ commit }, params) {
      return new Promise((resolve, reject) => {
        api
          .activateTask(params)
          .then((res) => {
            resolve(res)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    async updateFormKey({ commit }, params) {
      let { task_id, data } = params
      let taskDetail = {}
      await api.getTaskDetail({ task_id }).then((res) => {
        taskDetail = JSON.parse(JSON.stringify(res))
      })
      let dataset = {
        task_id,
        sort: taskDetail.sort || 0,
        task_name: taskDetail.task_name || '',
        task_stage: taskDetail.task_stage || '',
        project_id: taskDetail.project_id || 0,
        task_list_id: taskDetail.task_list_id || [],
        template_id: taskDetail.template.id || 0,
        sort_rule_id: taskDetail.sort_rule_id || '',
        executor: !taskDetail.executor || taskDetail.executor == 0 ? '' : taskDetail.executor,
        start_time: taskDetail.start_time || '',
        end_time: taskDetail.end_time || '',
        task_members: taskDetail.task_members_user && taskDetail.task_members_user.length > 0 ? taskDetail.task_members_user.map((res) => res.uid) : '',
        standard_components_values: taskDetail.template.template_standard_components
          .map((res) => {
            return {
              component_id_in_template: res.id,
              component_value: Vue['$' + res.component_code].getDefaultValue(res.component_values) || ''
            }
          })
          .filter((res) => res.component_value)
      }
      for (let key in data) {
        dataset[key] = data[key]
      }
      return api.updateTaskView(dataset)
    },
    updateStatus({ commit }, params) {
      let { task_id, task_stage } = params
      return api.updateTaskStage({ task_id: task_id, task_stage })
    },
    async updateKeyValue({ commit }, params) {
      console.log('-------------', params)
      let { task_id, data, temp } = params
      let taskDetail = {}
      await api.getTaskDetail({ task_id }).then((res) => {
        taskDetail = JSON.parse(JSON.stringify(res))
      })
      let dataset = {
        task_id,
        sort: taskDetail.sort || 0,
        task_name: taskDetail.task_name || '',
        task_stage: taskDetail.task_stage || '',
        project_id: taskDetail.project_id || 0,
        task_list_id: taskDetail.task_list_id || [],
        template_id: taskDetail.template.id || 0,
        sort_rule_id: taskDetail.sort_rule_id || '',
        executor: !taskDetail.executor || taskDetail.executor == 0 ? '' : taskDetail.executor,
        task_members: taskDetail.task_members_user && taskDetail.task_members_user.length > 0 ? taskDetail.task_members_user.map((res) => res.uid) : '',
        standard_components_values: taskDetail.template.template_standard_components
          .map((res) => {
            if (res.id !== data.id) {
              return {
                component_id_in_template: res.id,
                component_value: Vue['$' + res.component_code].getDefaultValue(res.component_values) || ''
              }
            }
          })
          .filter((res) => res && res.component_value)
      }
      dataset.standard_components_values.push({
        component_id_in_template: data.id,
        component_value: data.value || ''
      })
      if (taskDetail.start_time) {
        dataset.start_time = taskDetail.start_time
        dataset.end_time = taskDetail.end_time
      } else {
        dataset.start_time = ''
        dataset.end_time = ''
      }
      return api.updateTaskView(dataset)
    },
    getTaskMember({ commit, state }, params) {
      return new Promise((resolve, reject) => {
        api
          .getTaskMembers(params)
          .then((res) => {
            let dataset = []
            res.forEach((res) => {
              for (let key in res) {
                dataset.push({
                  realname: key,
                  children: res[key]
                })
              }
            })
            resolve(dataset)
            state.member = JSON.parse(JSON.stringify(dataset))
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    async getTaskListTable({ commit, state }, params) {
      let result = await api.taskListToSimpleIndex(params)
      state.taskList = JSON.parse(JSON.stringify(result.unarchived_task_lists.task_lists))
      return result
    },
    async getFilter({ commit, state }, params) {
      let result = await api.getFilterData(params)
      state.queryMsg.source_filter = result.source_filter ? result.source_filter.map((res) => Number(res)) : []
      state.queryMsg.status_filter = result.status_filter > 0 ? Number(result.status_filter) : ''
      state.queryMsg.sorting_rules = result.sorting_rules ? result.sorting_rules : []
      state.queryMsg.sort_switch = result.sort_switch ? result.sort_switch : 0
    }
  }
}
